import{MODE as o}from"./mode.js";var m={mode:o.DARK},e={mode:o.LIGHT};export{m as DARK,e as LIGHT};
